<template>
  <section class="p-2">
   
  <div class="pb-16">
    <!-- <div>
      <v-row justify="center">
        <v-alert
          v-if="alertMsg.status"
          :timeout="alertMsg.timeout"
          :color="alertMsg.color"
          :type="alertMsg.type"
          dismissible
          dark
          dense
        >
          {{ alertMsg.text }}
        </v-alert>
      </v-row>
    </div> -->
    <v-card elevation="2" tile flat outlined class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize"><v-icon small>mdi-content-save-plus-outline</v-icon>Add New Role</div>
        <div>
          <bread-crumb :bread-crumbs="['New Role']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-card-title><v-icon small>mdi-content-save-plus-outline</v-icon>Add New Role</v-card-title> -->
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col-md-6 margin-y">
              <label class="my-0 labelFontsize">Role Name</label>
              <v-text-field
                v-model="role_params.role_name"
                :rules="roleNameRules"
                outlined
                class="rounded"
              ></v-text-field>
              <label class="my-0 labelFontsize">Role Description</label>
              <v-textarea
                v-model="role_params.description"
                :rules="roleDescriptionRules"
                outlined
                class="rounded"
              ></v-textarea>
            </div>
            <div class="col-md-6">
              <div>
                <div class="subheading">
                  <v-switch
                    :rules="[(v) => !!v || 'You must agree to continue!']"
                    v-model="EnableExpiryDatePicker"
                    :label="`Role Expiry: ${EnableExpiryDatePicker.toString()}`"
                  ></v-switch>
                </div>
                <p v-show="expiarydateerror" style="color: #ff5252">
                  Please select expiary date
                </p>
                <v-date-picker
                  :disabled="datepickerEnable"
                  v-model="role_params.expiry_date"
                  :rules="roleExpiaryRules"
                  full-width
                  class="mt-4"
                ></v-date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-12"
              style="display: flex; justify-content: center"
            >
              <v-btn depressed 
              small
                class="text-capitalize text-primary-color p-2"
                color="primary"
                @click="createNewRole()"
              >
              <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add Modules
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <br />
      <!-- assign module to role -->

      <!-- <v-card-title v-if="assignModuleToRoleEnable === true">
        Assign Module To <b>{{ roleId }}</b> Role
      </v-card-title>
      <v-card-text v-if="assignModuleToRoleEnable === true">
        <v-row>
          <v-col v-for="(module, index) in AllModules" :key="index">
            <v-chip class="ma-2" outlined
              ><v-switch
                v-model="selectedAssignedModules"
                color="info"
                :value="module['module_id']"
                :label="module['module_name']"
              ></v-switch
            ></v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="display: flex; justify-content: center">
            <v-btn depressed 
              class="text-capitalize text-primary-color p-2"
              color="primary"
              @click="assignModuleTorole()"
            >
              Assign Modules
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text> -->
    </v-card>
    <!-- assign module to role -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="40"></v-progress-circular>
    </v-overlay>
    <permissions
      v-if="pemissionsEnable === true"
      :roleCode="roleCode"
      :roleName="roleName"
      :roleId="roleId"
    />
  </div>
</section>
</template>

<script>

import BreadCrumb from "@/components/navigations/BreadCrumb.vue"
import axios from "axios";
import permissions from "./components/permissionComponent.vue";
export default {
  name: "New Role",
  components: { permissions ,BreadCrumb},
  data() {
    return {
      valid: true,
      roleNameRules: [
        (v) => !!v || "Role Name is required"
        // (v) => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      roleDescriptionRules: [
        (v) => !!v || "Role Description is required"
        // (v) => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      roleExpiaryRules: [
        (v) => !!v || "Role Expiary is required"
        // (v) => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      alertMsg: {
        status: false,
        text: "",
        timeout: 2000,
        color: "",
        type: "info"
      },
      // assignModuleToRoleEnable: false,
      overlay: false,
      expiarydateerror: false,
      selectedAssignedModules: [],
      AllModules: [],
      pemissionsEnable: false,
      RoleName: "",
      RoleDescription: "",
      RoleExpiry: "",
      EnableExpiryDatePicker: false,
      role_params: {
        description: "",
        expiry_date: "",
        role_name: ""
      },
      roleCode: "",
      roleName: "",
      roleId: "",
      assignModulesToRoleParams: {
        role_id: null,
        module_list: []
      }
    };
  },
  watch: {
    selectedAssignedModules(val) {
      console.log(val);
    }
  },
  computed: {
    datepickerEnable() {
      if (this.EnableExpiryDatePicker === false) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    // this.getAllModules();
  },
  methods: {
    createNewRole() {
      let validatingDetails = this.$refs.form.validate();
      //
      //

      if (validatingDetails) {
        this.overlay = true;
        if (this.role_params.expiry_date !== "") {
          axios
            .post(
              `${process.env.VUE_APP_BASEURL}:8005/api/v1/roles/create_role`,
              this.role_params,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                  accept: "application/json"
                }
              }
            )
            .then((responseData) => {
              console.log("responseData", responseData.data.data[0].role_code);
              this.roleCode = responseData.data.data[0].role_code;
              this.roleName = responseData.data.data[0].role_name;
              this.roleId = responseData.data.data[0].role_id;
              this.pemissionsEnable = true;
              this.overlay = false;
              // this.assignModuleToRoleEnable = true;
              // let roledata = this.getRoleDate(responseData.data.data[0].role_code);
              // console.log("role data", roledata);
            })
            .catch((error) => {
              console.log("error.response", error.response.data.detail[0].msg);
              this.alertMsg = {
                status: true,
                text: error.response.data.detail[0].msg,
                timeout: 2000,
                color: "error",
                type: "info"
              };
              this.overlay = false;
            });
        } else {
          this.overlay = false;
          this.expiarydateerror = true;
        }
      }
    }
    // getAllModules() {
    //   axios
    //     .get(`${process.env.VUE_APP_BASEURL}:8005/api/v1/module/all_modules`, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
    //         accept: "application/json"
    //       }
    //     })
    //     .then((responseData) => {
    //       this.AllModules = responseData.data.data;
    //       console.log("all modules", responseData.data.data);
    //     });
    // }
    // assignModuleTorole() {
    //   (this.assignModulesToRoleParams.role_id = this.roleId),
    //     (this.assignModulesToRoleParams.module_list =
    //       this.selectedAssignedModules);

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_BASEURL}:8005/api/v1/roles/add_module`,
    //       this.assignModulesToRoleParams,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
    //           accept: "application/json"
    //         }
    //       }
    //     )
    //     .then((responseData) => {
    //       console.log("responseData", responseData);
    //       this.pemissionsEnable = true;
    //     });
    // }
  }
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
.margin-y {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
